import { Command } from 'commander';
import { detectWorkspace, folderForSelector, readMeta } from '../config-as-code/workspace.js';
import { readBinding, writeBinding } from '../base-binding.js';

export const useCommand = new Command('use')
  .description('Bind this worktree to a database so push/pull refuse to run against a different one')
  .argument('<database>', 'Base id (e.g. prod--my-preview), or a folder name under rekor-ws/bases')
  .action(async (selector: string) => {
    const baseId = resolveSelectorToBaseId(selector);

    const previous = readBinding();
    if (previous === baseId) {
      console.log(`Worktree already bound to ${baseId}.`);
      return;
    }

    writeBinding(baseId);
    if (previous) {
      console.log(`Worktree rebound: ${previous} → ${baseId}.`);
    } else {
      console.log(`Worktree bound to database ${baseId}.`);
    }
  });

/**
 * Resolve a `use` selector to a database id: if it names a tracked folder under `rekor-ws/bases`
 * (one with a `base_id`), use that id; otherwise treat the selector as the literal id. Mirrors
 * wayai's "UUID or folder name" so `rekor use my-preview` and `rekor use prod--my-preview` both work.
 */
function resolveSelectorToBaseId(selector: string): string {
  const ws = detectWorkspace();
  if (ws) {
    const meta = readMeta(folderForSelector(ws, selector));
    if (meta?.base_id) return meta.base_id;
  }
  return selector;
}
